import { array, oneOf, oneOfType, shape, string } from "prop-types";

import __ from "web/Layout/Translations";

import classify from "web/classify";

import defaultClasses from "./definition.scss";

const CheckoutSubscriptionLegendDefinition = ({
  classes,
  message,
  children,
}) => {
  return (
    <div className={classes.root}>
      {children}
      <div className={classes.tooltip}>{__(message)}</div>
    </div>
  );
};

CheckoutSubscriptionLegendDefinition.propTypes = {
  children: oneOfType([array, shape({}), oneOf([null])]),
  classes: shape({}).isRequired,
  message: string,
};
CheckoutSubscriptionLegendDefinition.defaultProps = {
  children: null,
  message: string,
};

export default classify(defaultClasses)(CheckoutSubscriptionLegendDefinition);
